import React from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import "./apps.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Error404 from "../404/404";
import { getApp } from "../../../Constants/Apps";
import { APPS_CONTENT } from "../../../Constants/AppsContent";
import { useTranslation } from "../../../Hooks/useTranslation";
import { useReveal } from "../../../Hooks/useReveal";

// Estructura común de /apps/:appId, /privacidad, /terminos y /contrata (pestaña "Planes" solo si la app los tiene)
const AppShell = ({ children }) => {
  const { appId } = useParams();
  const { t, language } = useTranslation();
  const app = getApp(appId);
  useReveal();

  if (!app) return <Error404 />;
  const content = APPS_CONTENT[language][app.id];

  return (
    <>
      <Navbar />
      <main
        className="app-page"
        style={{ "--app-accent": app.accent, "--app-accent-dark": app.accentDark }}
      >
        <section className="app-hero">
          <div className="app-hero-glow" aria-hidden="true" />
          <div className="container app-hero-inner">
            <Link to="/apps" className="app-back">
              ← {t.apps.back}
            </Link>
            <div className="app-hero-head hero-anim" style={{ "--d": 0 }}>
              <img className="app-hero-icon" src={app.icon} alt={app.name} />
              <div>
                <h1>{app.name}</h1>
                <p className="app-hero-tagline">{content.tagline}</p>
                <div className="tags">
                  {app.tags.map((tag) => (
                    <span key={tag} className="tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
            <div className="app-hero-actions hero-anim" style={{ "--d": 1 }}>
              {app.storeLink && (
                <a className="btn app-store-btn" href={app.storeLink} target="_blank" rel="noopener noreferrer">
                  {t.apps.download}
                </a>
              )}
              {app.playStoreLink && (
                <a className="btn app-play-btn" href={app.playStoreLink} target="_blank" rel="noopener noreferrer">
                  {t.apps.downloadPlay}
                </a>
              )}
              {!app.storeLink && !app.playStoreLink && (
                <span className="btn app-store-btn is-soon">{t.apps.comingSoon}</span>
              )}
            </div>
            <nav className="app-tabs hero-anim" style={{ "--d": 2 }} aria-label={app.name}>
              <NavLink end to={`/apps/${app.id}`}>{t.apps.about}</NavLink>
              {content.contrata && <NavLink to={`/apps/${app.id}/contrata`}>{t.apps.plans}</NavLink>}
              <NavLink to={`/apps/${app.id}/privacidad`}>{t.apps.privacy}</NavLink>
              {content.terms && <NavLink to={`/apps/${app.id}/terminos`}>{t.apps.terms}</NavLink>}
            </nav>
          </div>
        </section>
        {children({ app, content, t })}
      </main>
      <Footer />
    </>
  );
};

export default AppShell;
